import { Download } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import Search from "../../../components/Search";
import {
  create,
  deleteItem,
  exportAll,
  findEntityIsInUse,
  findPartnerById,
  update,
  useList,
} from "../../../services/partner";
import { getLocal, getToken } from "../../../storage/auth";
import { PartnerService } from "../../../types/partner";
import Form from "./components/Form";
import DataTable from "./components/DataTable";
import { hasClaim } from "../../../storage/userClaims";
import useForms from "../../utils/forms/useForm.hook";

interface IParams {
  page: number;
  keyword: string;
  sort: string;
  limit: number;
  uri: string;
  param: string;
}

export default function Partner() {
  const [partner, setPartner] = useState<PartnerService>({} as PartnerService);
  const [token, setToken] = useState<string>();
  const [userValidation, setUserValidation] = useState<string>();
  const [entityInUse, setEntityInUse] = useState<boolean>(false);

  const getTokenSession = () => {
    const getTokens = (getToken()) as any;
    const getUser = (getLocal("userInfo")) as any;
    try {
      setUserValidation(JSON.parse(getUser));
      setToken(getTokens);
    } catch (err) {
      // console.log(err)
    }
  };
  useEffect(() => {
    getTokenSession();
  }, []);

  const [params, setParams] = useState<IParams>({
    page: 1,
    limit: 10,
  } as IParams);

  const { data, meta, country, consolidationCenter, center, freightForwarder } = useList(params, token);

  const {
    selectedData,
    isSaving,
    modalOpen,
    setModalOpen,
    openDeleteModal,
    setOpenDeleteModal,
    errors,
    paginationModel,
    readOnly,
    setPaginationModel,

    handleRequest,
    handleEditData,
    handleDeleteDataConfirmation,
    handleDeleteData,
    handleFormSubmit,
    exportData,
    handleCancelEditData,
    onViewData,
    onNew,
  } = useForms({
    actions: {
      create,
      deleteData: deleteItem,
      exportAll,
      update,
      isInUse: findEntityIsInUse
    },
    configs:{
      findKey: "ID_PARCEIRO",
      entityName: "Partner",
    },

    data,
    params,
    setParams
  });


  useEffect(() => {
    if (selectedData.ID_PARCEIRO) {
      findPartnerById(selectedData.ID_PARCEIRO).then((partnerResponse) => {
        setPartner(partnerResponse);
      });
      findEntityIsInUse(selectedData.ID_PARCEIRO).then((inUse) => {
        setEntityInUse(inUse);
      });
    }
  }, [selectedData]);

  return (
    <Grid marginTop={4}>
      <Grid container spacing={1} direction="column">
        <Grid item xs={10}>
          <Typography variant="h5" id="header-title">Partner</Typography>
        </Grid>
        {!modalOpen ? (
          <Grid item xs={2} marginTop={1}>
            <Button
              sx={{
                display: hasClaim("Partner - Maintenance") ? "block" : "none",
              }}
              variant="contained"
              onClick={() => { onNew(); setPartner({} as PartnerService); setEntityInUse(false) }}
              data-testid="new-button"
            >
              New
            </Button>
          </Grid>
        ) : null}
      </Grid>
      {modalOpen ? (
        <Grid container alignItems="center">
          <Form
            readOnly={readOnly}
            entityInUse={entityInUse}
            onSubmit={handleFormSubmit}
            partner={partner}
            partnerId={selectedData}
            onCancel={handleCancelEditData}
            country={country}
            center={center}
            freightForwarder={freightForwarder}
            isLoading={isSaving}
            errors={errors}
          />
        </Grid>
      ) : null}
      <Search onChange={handleRequest} consolidationCenterCombo={consolidationCenter} slaType disableStatus/>
      <Grid container marginTop={4} justifyContent="flex-end">
        <Button
          variant="text"
          onClick={exportData}
          startIcon={<Download />}
        >
          Export XLSX
        </Button>
      </Grid>
      <Grid>
        <DataTable
          loading={isSaving}
          data={data}
          onDelete={handleDeleteDataConfirmation}
          onEdit={(input) => { window.location.href = '#header-title'; handleEditData(input) }}
          onView={(input) => { window.location.href = '#header-title'; onViewData(input) }}
          userValidation={userValidation}
          rowCount={meta?.total || 0}
          onPaginationModelChange={(e: any) => {
            setPaginationModel(e);
            handleRequest({ page: e.page + 1, limit: e.pageSize });
          } }
          pagination
          paginationModel={paginationModel}
          initialState={{
            pagination: { paginationModel: { pageSize: params.limit } },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
        />
      </Grid>
      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Partner</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure that you want to delete this Partner?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteModal(false)}>Cancel</Button>
          <Button onClick={handleDeleteData}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
